import { Helmet } from 'react-helmet-async';

import { PageHeader } from '@ant-design/pro-components';

import ReminderLetterContent from '../ReminderLetterContent';

const ReminderLetter1Listing = () => {
  return (
    <>
      <Helmet>
        <title>Reminder Letter 1 - RedCash Collection</title>
      </Helmet>
      <PageHeader className="px-0 mb-2" title="Reminder Letter 1" />
      <ReminderLetterContent letterNumber="1" />
    </>
  );
};

export default ReminderLetter1Listing;
